
export const mapToPeriodDictionary = (period) => {
    const dictionary = {
        T1:     "oneDay",
        T30:    "oneMonth",
        T365:   "oneYear", 
    }

    return dictionary[period]
}

export const mapToTypeDictionary = (type) => {
    const dictionary = {
        percent:    "PercentChange",
        nominal:    "NominalChange",
    }

    return dictionary[type]
}